import classNames from 'classnames';
import React from 'react';

import ParameterComponent from 'sharedreact/components/ParameterComponent';
import SegmentedButton, { SegmentType } from 'sharedreact/components/SegmentedButton';

type Props = {
  id: string,
  className?: string,
  btnClassName?: string,
  segmentClassName?: string,
  name: string,
  label: string,
  value: string,
  segments: SegmentType[],
  disabled?: boolean,

  onChangeValue: (name: string, segmendId: string, event?: React.MouseEvent<HTMLButtonElement>) => void
};

class SegmentedButtonField extends React.PureComponent<Props> {
  constructor (props: Props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick (value: string, event?: React.MouseEvent<HTMLButtonElement>) {
    const { name, onChangeValue } = this.props;

    onChangeValue(name, value, event);
  }

  override render (): React.ReactNode {
    const { id, className, btnClassName, segmentClassName, label,
      value, segments, disabled } = this.props;

    return (
      <ParameterComponent
        className={className}
        inputId={id}
        label={label}
        inputContainer={false}>
        <div className='esko_forminput esko_segbutton_inputpadding'>
          <SegmentedButton id={id}
            className={classNames('esko_input-group-btn', 'esko_segbuttonpaddingcorrection', btnClassName)}
            segmentClassName={segmentClassName}
            disabled={disabled}
            stretch={false}
            segments={segments}
            selectedId={value}
            onClick={this.handleClick}
          />
        </div>
      </ParameterComponent>
    );
  }
}

export default SegmentedButtonField;
